import Vue from 'vue';
// import './pollyfills';
import moment from 'moment';
Vue.prototype.moment = moment
moment.locale("en");
import {
    Pagination,
    Dialog,
    Autocomplete,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Menu,
    Submenu,
    MenuItem,
    MenuItemGroup,
    Input,
    InputNumber,
    Radio,
    RadioGroup,
    RadioButton,
    Checkbox,
    CheckboxButton,
    CheckboxGroup,
    Switch,
    Select,
    Option,
    OptionGroup,
    Button,
    ButtonGroup,
    Table,
    TableColumn,
    DatePicker,
    TimeSelect,
    TimePicker,
    Popover,
    Tooltip,
    Breadcrumb,
    BreadcrumbItem,
    Form,
    FormItem,
    Tabs,
    TabPane,
    Tag,
    Tree,
    Alert,
    Slider,
    Icon,
    Row,
    Col,
    Upload,
    Progress,
    Spinner,
    Badge,
    Card,
    Rate,
    Steps,
    Step,
    Carousel,
    CarouselItem,
    Collapse,
    CollapseItem,
    Cascader,
    ColorPicker,
    Transfer,
    Container,
    Header,
    Aside,
    Main,
    Footer,
    Timeline,
    TimelineItem,
    Link,
    Divider,
    Image,
    Calendar,
    Backtop,
    PageHeader,
    CascaderPanel,
    Loading,
    MessageBox,
    Message,
    Notification,
    InfiniteScroll
} from 'element-ui';

import 'element-ui/lib/theme-chalk/index.css';


import VueRouter from 'vue-router';
import VueRouterPrefetch from 'vue-router-prefetch';
import VueNotify from 'vue-notifyjs';
import { ValidationProvider } from 'vee-validate';

import lang from 'element-ui/lib/locale/lang/cs-CZ';
import locale from 'element-ui/lib/locale';
locale.use(lang);

import axios from 'axios';

import App from './App.vue';

import { Laue } from 'laue';

// Plugins
import GlobalComponents from './globalComponents';
import GlobalDirectives from './globalDirectives';

// router setup
import routes from './routes';
import store from './stores';

// library imports
import './assets/sass/main.scss';

import 'element-ui/lib/theme-chalk/display.css';

import './registerServiceWorker';

import initProgress from './progressbar';

Vue.use(moment);
// Vue.use(axios);

// plugin setup
Vue.use(VueRouter);
Vue.use(VueRouterPrefetch);
Vue.use(GlobalDirectives);
Vue.use(GlobalComponents);
Vue.use(VueNotify);
Vue.component('ValidationProvider', ValidationProvider);

Vue.use(Pagination);
Vue.use(Dialog);
Vue.use(Autocomplete);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Checkbox);
Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
Vue.use(Switch);
Vue.use(Select);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(Button);
Vue.use(ButtonGroup);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(DatePicker);
Vue.use(TimeSelect);
Vue.use(TimePicker);
Vue.use(Popover);
Vue.use(Tooltip);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Tag);
Vue.use(Tree);
Vue.use(Alert);
Vue.use(Slider);
Vue.use(Icon);
Vue.use(Row);
Vue.use(Col);
Vue.use(Upload);
Vue.use(Progress);
Vue.use(Spinner);
Vue.use(Badge);
Vue.use(Card);
Vue.use(Rate);
Vue.use(Steps);
Vue.use(Step);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Cascader);
Vue.use(ColorPicker);
Vue.use(Transfer);
Vue.use(Container);
Vue.use(Header);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Footer);
Vue.use(Timeline);
Vue.use(TimelineItem);
Vue.use(Link);
Vue.use(Divider);
Vue.use(Image);
Vue.use(Calendar);
Vue.use(Backtop);
Vue.use(PageHeader);
Vue.use(Loading);
Vue.use(CascaderPanel);
Vue.use(InfiniteScroll);

Vue.use(Laue);

Vue.use(Loading.directive);

Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;



// configure router
const router = new VueRouter({
    mode: 'history',
    routes,
    linkActiveClass: 'active',
    scrollBehavior: (to) => {
        if (to.hash) {
            return { selector: to.hash }
        } else {
            return { x: 0, y: 0 }
        }
    }
})

Vue.use(router)

router.beforeEach((to, from, next) => {
    // redirect to login page if not logged in and trying to access a restricted page
    console.log(to);
    // const publicPages = ['/', '/welcome', '/registration', ];
    // const authRequired = !publicPages.includes(to.path);
    // const loggedIn = localStorage.getItem('token');

    // if (authRequired && !loggedIn) {
    //     return next('/welcome');
    // }
    next();
})





initProgress(router);

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App),

    created() {
        // axios.get(process.env.VUE_APP_BE + '/')
        //     .then(response => {
        //         this.$store.commit('m_l_hpo', response.data["l_hpo"]);
        //         this.$store.commit('m_l_icd11', response.data["l_icd11"]);
        //         this.$store.commit('m_l_ethnic', response.data["l_ethnic"]);
        //         this.$store.commit('m_l_countries', response.data["l_countries"]);
        //         this.$store.commit('m_hpo', response.data["hpo"]);
        //         this.$store.commit('m_l_gene', response.data["l_gene"]);
        //         this.$store.commit('m_l_consequences', response.data["l_consequences"]);
        //         this.$store.commit('m_l_features', response.data["l_features"]);
        //         this.$store.commit('m_l_clinvars', response.data["l_clinvars"]);
        //         this.$store.commit('m_l_clinvar_dns', response.data["l_clinvar_dns"]);
        //         this.$store.commit('m_d_a_cols', response.data["d_a_cols"]);
        //     }, error => {
        //         console.log(error);
        //     });

        if (this.$store.state.token) {
            this.$store.dispatch('a_load_profile');
        }

        var currentUrl = window.location;
        var application;
        this.$store.commit('m_current_url', currentUrl);

    },

    mounted() {
        axios.get(process.env.VUE_APP_BE + '/')
            .then(response => {
                this.$store.commit('m_l_insurance_companies', response.data["l_insurance_companies"]);
                this.$store.commit('m_l_depts', response.data["l_depts"]);
                this.$store.commit('m_users', response.data["users"]);
                this.$store.commit('m_l_exam_diagnozy', response.data["l_exam_diagnozy"]);
                this.$store.commit('m_l_diags', response.data["l_diags"]);


            }, error => {
                console.log(error);
            });


        var currentUrl = window.location;
        var application;
        if (currentUrl.hostname === "neon.bioxsys.cz") {
            application = "NEON"
        } else {
            application = "NEON"
        }
        this.$store.commit('m_application', application);


    },

})

export default router
